<template>
  <div class="container">
    <v-card>
      <v-card-title class="blue accent-1 gray--text">Listado de bins que han pasado por una planta</v-card-title>
      <v-card-text>
        <v-row class="mx-1">
            <v-col cols="4">
                <v-select
                    v-model="facility_id"
                    :items="facilities"
                    item-text="name"
                    item-value="id"
                    label="Elija Planta"
                    placeholder="Elija Planta"
                    @change="loadFacilityBinsReport"
                >
                </v-select>
            </v-col>
            <v-col cols="4">
                <label class="v-label v-label--active theme--light">Fecha Inicio</label>
                <date-picker 
                    placeholder="Fecha" 
                    class="dtpicker" 
                    v-model="start_date" 
                    format="DD-MM-YYYY" 
                    valueType="YYYY-MM-DD" 
                    @change="loadFacilityBinsReport"
                >
                </date-picker>
            </v-col>
            <v-col cols="4">
                <label class="v-label v-label--active theme--light">Fecha Termino</label>
                <date-picker 
                    placeholder="Fecha" 
                    class="dtpicker" 
                    v-model="end_date" 
                    format="DD-MM-YYYY" 
                    valueType="YYYY-MM-DD"
                     @change="loadFacilityBinsReport"
                >
                </date-picker>
            </v-col>
            <v-col cols="4">
                <v-btn @click="download" color="primary">Excel</v-btn>
            </v-col>
        </v-row>
        <v-data-table 
          :headers="binsFacilityListHeaders"
          :items="binsFacilityListBody"
          class="elevation-1"
          no-data-text="No hay datos"
          disable-pagination
          fixed-header
          :height="table_height"
        >
            <template v-slot:[`item.movement_date`]="{item}">
                {{ formatDate(item.movement_date )}}
            </template>
        </v-data-table>

        <table class="elevation-1">
            <tr>
                <td>Recibidos</td>
                <td>{{ resumen.recibidos }}</td>
            </tr>
            <tr>
                <td>Despachados</td>
                <td>{{ resumen.despachados }}</td>
            </tr>
            <tr>
                <td>Devueltos</td>
                <td>{{ resumen.devueltos }}</td>
            </tr>
            <tr>
                <td>En planta</td>
                <td>{{ resumen.en_planta }}</td>
            </tr>
        </table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
  import {mapState, mapMutations} from 'vuex';
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import 'vue2-datepicker/locale/es';

  export default {
    data: () => ({
        url_excel: '',
        start_date: new Date("2020-10-01").toISOString().substr(0, 10),
        end_date: new Date().toISOString().substr(0, 10),
        facility_id: 0,
        facilities: [],
        isLoading: false,
        table_height: 600,
        binsFacilityListHeaders: [
            {
                text: 'Fecha',
                align: 'center',
                sortable: true,
                value: 'movement_date',
                class: "salmon black--text elevation-1 elevation-3"
            },
            {
                text: 'Tipo Movimiento',
                align: 'center',
                sortable: true,
                value: 'type.name',
                class: "salmon black--text elevation-1 elevation-3"
            },
            {
                text: 'Guia',
                align: 'center',
                sortable: true,
                value: 'waybill',
                class: "salmon black--text elevation-1 elevation-3"
            },
            {
                text: 'Cliente',
                align: 'center',
                sortable: true,
                value: 'company.name',
                class: "salmon black--text elevation-1 elevation-3"
            },
            {
                text: 'Color',
                align: 'center',
                sortable: true,
                value: 'bin.color.name',
                class: "salmon black--text elevation-1 elevation-3"
            },
            {
                text: 'Tamaño',
                align: 'center',
                sortable: true,
                value: 'bin.size.name',
                class: "salmon black--text elevation-1 elevation-3"
            },
            {
                text: 'Numero',
                align: 'center',
                sortable: true,
                value: 'bin.number',
                class: "salmon black--text elevation-1 elevation-3"
            },
        ],
        binsFacilityListBody: [],
        resumen: {},
    }),
    mounted() {
      this.loadFacilities();
    },
    methods:{
        async loadFacilities(){
            let url = `${this.base_url}facilities`;
            await this.axios.get(url, this.headers).then((response)=>{
                this.facilities = response.data.data;
            }).catch((error)=>{
                console.log(error);
            });
        },
        async loadFacilityBinsReport(){
            if(this.facility_id == 0) return;
            this.mostrarLoading('Generando informe, por favor espere...');
            let url = `${this.base_url}reports/facility/bins/${this.facility_id}/${this.start_date}/${this.end_date}`;
            await this.axios.get(url, this.headers).then((response)=>{
                this.binsFacilityListBody = response.data.data.report_data;
                this.url_excel = this.storage_url + response.data.data.url_excel;
                this.resumen = response.data.data.resumen;
                this.ocultarLoading();
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },
        download(){
            window.location.href = this.url_excel;
        },
        formatDate (date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${day}-${month}-${year}`
        },
        ...mapMutations(['actualizarBaseUrl', 'actualizarUrlStorage', 'mostrarLoading', 'ocultarLoading']),
    },
    computed:{
      ...mapState(['authenticated', 'loading', 'base_url', 'storage_url', 'headers'])
    },
    components:{
        DatePicker
    }
  }
</script>